<template>
  <div class="xl:col-span-4 lg:col-span-5 col-span-12 mb-5">
    <Card :title="title">
      <ul class="divide-y divide-slate-100 dark:divide-slate-700">
        <li class="block py-[8px]">
          <div class="animate-pulse">
            <div class="flex space-x-4 rtl:space-x-reverse justify-between">
              <div class="flex-1 flex space-x-4 rtl:space-x-reverse max-w-sm">
                <div class="flex-none">
                  <div class="flex-none bg-[#C4C4C4] dark:bg-slate-500 h-8 w-8 rounded-circile">

                  </div>
                </div>
                <div class="flex-1">
                  <div
                      class="rounded text-sm mb-3 font-medium h-2 bg-[#C4C4C4] dark:bg-slate-500"
                  >

                  </div>

                  <div class="mt-4 rounded w-full h-2 bg-[#C4C4C4] dark:bg-slate-500">

                  </div>

                  <div class="mt-4 rounded w-full h-2 bg-[#C4C4C4] dark:bg-slate-500">

                  </div>

                </div>
              </div>
              <div class="flex-none">
                <div class="rounded w-full h-6 w-20 bg-[#C4C4C4] dark:bg-slate-500">

                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/Card/index.vue";

export default {
  name: "Session",
  components: {
    Card,
  },
  props:{
    title: {
      type: String,
      default: '',
    },
  }
}
</script>

<style scoped>

</style>
